/*
 * Public AG Grid event names (v31+). Replaces removed internal `Events` enum.
 * Prefer these or `api.addEventListener('<name>', ...)` with `AgPublicEventType`.
 */
export const GRID_EVENT = {
  rowClicked: 'rowClicked',
  sortChanged: 'sortChanged',
  modelUpdated: 'modelUpdated',
  rowSelected: 'rowSelected',
  gridSizeChanged: 'gridSizeChanged',
  bodyScroll: 'bodyScroll',
  columnResized: 'columnResized',
  viewportChanged: 'viewportChanged',
  gridReady: 'gridReady',
  virtualRowRemoved: 'virtualRowRemoved' as const,
  rowDragEnter: 'rowDragEnter',
  rowDragEnd: 'rowDragEnd',
} as const;

export type GridPublicEventName = (typeof GRID_EVENT)[keyof typeof GRID_EVENT];
